import React, { FC } from 'react';
import { ChevronDown } from '@td-client-frontend/icons';
import clsx from 'clsx';

export const Expand: FC<{ expanded: boolean }> = ({ expanded }) => {
  return (
    <ChevronDown className={clsx('w-5 h-5 transform inline ml-2', expanded ? '-rotate-180' : 'rotate-0')} aria-hidden />
  );
};
